import PropTypes from 'prop-types';
import React from 'react';

import styles from './IntakeLink.module.scss';

const IntakeLink = ({ link, onOpen, title = 'Open intake form' }) => {
  const hasLink = Boolean(link);

  return (
    <a
      href={hasLink ? link : undefined}
      target="_blank"
      rel="noreferrer"
      className={`${styles.link} ${hasLink ? '' : styles.disabled}`}
      aria-disabled={!hasLink}
      onClick={(event) => {
        if (!hasLink) {
          event.preventDefault();
          return;
        }
        if (onOpen) {
          event.preventDefault();
          onOpen();
        }
      }}
    >
      <div className={styles.badge}>
        <span className={styles.badgeText}>I</span>
      </div>
      <div className={styles.meta}>
        <span className={styles.title}>{title}</span>
      </div>
      <span className={styles.arrow} aria-hidden="true">
        ↗
      </span>
    </a>
  );
};

IntakeLink.propTypes = {
  link: PropTypes.string,
  onOpen: PropTypes.func,
  title: PropTypes.string,
};

export default IntakeLink;
